import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTriggerButton,
} from '@customerio/pluma-components/react';
import type { ObjectType } from '@/services/db/object-type/entity';
import { generatePath } from '@/services/router/generate-path';

type AddObjectDropdownProps = {
  objectType: ObjectType;
  workspaceId: number;
  canCreate: boolean;
  canCreateRelationships: boolean;
  onAddRelationships: () => void;
};

export function AddObjectDropdown({
  objectType,
  workspaceId,
  canCreate,
  canCreateRelationships,
  onAddRelationships,
}: AddObjectDropdownProps) {
  const label = `Add ${/^[aeiou]/i.test(objectType.singular_name) ? 'an' : 'a'} ${objectType.singular_name}`;
  const importHref = `${generatePath('/workspaces/:workspaceId/journeys/imports/new', { workspaceId })}?${new URLSearchParams(
    {
      type: 'object',
      objectTypeId: objectType.id,
    },
  )}`;
  const addHref = generatePath('/workspaces/:workspaceId/journeys/objects/:objectSlug/new', {
    workspaceId,
    objectSlug: objectType.slug,
  });

  return (
    <DropdownMenu>
      <DropdownMenuTriggerButton variant="primary" icon="chevron-down" iconPosition="trailing" isDisabled={!canCreate}>
        {label}
      </DropdownMenuTriggerButton>
      <DropdownMenuContent>
        <DropdownMenuItem href={importHref}>Import a CSV</DropdownMenuItem>
        <DropdownMenuItem href={addHref}>{label}</DropdownMenuItem>
        {objectType.object_count > 0 && canCreateRelationships ? (
          <DropdownMenuItem onClick={onAddRelationships}>Add relationships</DropdownMenuItem>
        ) : null}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
